import Lottie from "lottie-react";
import animationData from "@/assets/lottie/health_vitals.json"; // Adjust path as needed

const LoadingAnimation = () => {
  return (
    <div className="m-auto" style={{ width: "150px", height: "150px" }}>
      <Lottie animationData={animationData} loop={true} />
    </div>
  );
};

export default LoadingAnimation;
